import React, { FC } from 'react';
import { BoxContent, BoxMain } from 'components';
import { useTranslation } from 'react-i18next';
import { FlexProps } from '@chakra-ui/react';

interface Props {
  includeRightMargin?: boolean;
  boxWidth: BoxWidth;
}

const ProjectBox: FC<Props & FlexProps> = ({ children, includeRightMargin, boxWidth, ...rest }) => {
  const { ready } = useTranslation('projects');

  return (
    <BoxContent boxWidth={boxWidth} includeRightMargin={includeRightMargin} {...rest} animate>
      <BoxMain ready={ready} overlayHeight="1300px" overlayType="splitted">
        {children}
      </BoxMain>
    </BoxContent>
  );
};

export default ProjectBox;
